module.exports = __webpack_public_path__ + "static/media/bells.ee584ccb.svg";